export var HOME_BUDGET_CALCULATOR_VERSION;
(function (HOME_BUDGET_CALCULATOR_VERSION) {
    HOME_BUDGET_CALCULATOR_VERSION["V1"] = "1.0";
    HOME_BUDGET_CALCULATOR_VERSION["V2"] = "2.0";
})(HOME_BUDGET_CALCULATOR_VERSION || (HOME_BUDGET_CALCULATOR_VERSION = {}));
export var LATEST_HOME_BUDGET_CALCULATOR_VERSION = HOME_BUDGET_CALCULATOR_VERSION.V2;
//# sourceMappingURL=index.js.map